export const host = process.env.REACT_APP_SITE_PATH || 'http://localhost:8081'

export const teacher_signin = 'teachers/signin'
export const refresh_token = "auth/refreshToken"
export const auth_signin = "company_form/signin"
export const auth_signinv2 = "user/signin"
export const get_user = "company_form/me"
export const teachers = "/teachers"
export const students = "/students"
export const courses = "/courses"
export const groups = "/groups"
export const payment = "/payment"
export const get_user_by_id = "auth/getById"

